import { Printer } from "lucide-react";

export const PrintButton = ({ label = "Print / Save PDF", testid = "print-page-button" }) => {
  return (
    <button type="button" onClick={() => window.print()} className="ic-btn" data-testid={testid}>
      <Printer size={16} />
      {label}
    </button>
  );
};
